import { render, staticRenderFns } from "./helpcenter-support-request.vue?vue&type=template&id=6796cc6a&"
import script from "./helpcenter-support-request.vue?vue&type=script&lang=js&"
export * from "./helpcenter-support-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports